/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { Component, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { ConvertForDataTestPipe, createEmptyStateResource, StateResource } from '@common/tech-shared';
import { ButtonComponent, TooltipDirective } from '@ods/system';
import { DeleteDeviceDialogComponent } from '../delete-device-dialog/delete-device-dialog.component';
import { RenameDeviceDialogComponent } from '../rename-device-dialog/rename-device-dialog.component';

@Component({
  selector: 'administration-device-actions',
  imports: [ButtonComponent, ConvertForDataTestPipe, DeleteDeviceDialogComponent, RenameDeviceDialogComponent, TooltipDirective],
  templateUrl: './device-actions.component.html',
})
export class DeviceActionsComponent {
  public readonly deviceName: InputSignal<string> = input.required<string>();
  public readonly deviceLabel: InputSignal<string> = input.required<string>();
  public readonly renameStateResource: InputSignal<StateResource<string>> =
    input<StateResource<string>>(createEmptyStateResource<string>());
  public readonly deleteStateResource: InputSignal<StateResource<string>> =
    input<StateResource<string>>(createEmptyStateResource<string>());

  public readonly renamed: OutputEmitterRef<string> = output<string>();
  public readonly deleted: OutputEmitterRef<void> = output<void>();
}
